var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DefaultLayoutVue',[(_vm.deviceId=='list')?_c('ListDeviceComp'):_c('DetailDeviceComp',{attrs:{"deviceId":_vm.deviceId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }